import { useState } from "react";
import { Button } from "@mui/material";
import ConfirmationDialog from "./ConfirmationDialog";

const ButtonWithConfirmation = props => {
  const [isVisible, setIsVisible] = useState(false);
  const { message, onClick, CustomButton, ...buttonProps } = props;

  const toggleVisibility = () => setIsVisible(isVisible => !isVisible);
  const ButtonToUse = CustomButton || Button;

  return <>
    <ButtonToUse onClick={toggleVisibility} {...buttonProps} />
    <ConfirmationDialog isVisible={isVisible} setIsVisible={setIsVisible} message={message} onConfirm={onClick} />
  </>
};

export default ButtonWithConfirmation;